import request from '../utils/request'

export function subjectLevelList(data) { // 等级列表
  return request({
    url: '/api/signup/subjectLevel/index',
    method: 'POST',
    data
  })
}

